import { fetchApi } from "../utils/fetchApi";

export function fetchCurrentstatus({ filter = {}, options = {} }) {  
  return fetchApi({ url: 'currentstatus', filter, options });
}

